import { J2000 } from "./AstroConstants.js";
const dTA = 32.184;
const K = 1.657e-3;
const EB = 1.671e-2;
const M0 = 6.239996;
const M1 = 1.99096871e-7;
const LeapSeconds = [
    [10, 2441317.5],
    [11, 2441499.5],
    [12, 2441683.5],
    [13, 2442048.5],
    [14, 2442413.5],
    [15, 2442778.5],
    [16, 2443144.5],
    [17, 2443509.5],
    [18, 2443874.5],
    [19, 2444239.5],
    [20, 2444786.5],
    [21, 2445151.5],
    [22, 2445516.5],
    [23, 2446247.5],
    [24, 2447161.5],
    [25, 2447892.5],
    [26, 2448257.5],
    [27, 2448804.5],
    [28, 2449169.5],
    [29, 2449534.5],
    [30, 2450083.5],
    [31, 2450630.5],
    [32, 2451179.5],
    [33, 2453736.5],
    [34, 2454832.5],
    [35, 2456109.5],
    [36, 2457204.5],
    [37, 2457754.5], // 1 Jan 2017
];
export function TDBtoJD(tdb) {
    return TAItoJD(TTtoTAI(TDBtoTT(tdb)));
}
export function TDBtoTT(tdb) {
    return tdb - secsToDays(TDBcorrection(tdb));
}
export function TTtoTAI(tt) {
    return tt - secsToDays(dTA);
}
export function TAItoJD(tai) {
    let dAT = LeapSeconds[0][0];
    let extraSecs = 0;
    for (let i = LeapSeconds.length - 1; i > 0; i--) {
        if (tai - secsToDays(LeapSeconds[i][0]) >= LeapSeconds[i][1]) {
            dAT = LeapSeconds[i][0];
            break;
        }
        else if (tai - secsToDays(LeapSeconds[i - 1][0]) >=
            LeapSeconds[i][1]) {
            dAT = LeapSeconds[i][0];
            extraSecs = LeapSeconds[i][0] - LeapSeconds[i - 1][0];
            break;
        }
    }
    return tai - secsToDays(dAT) + extraSecs / 86400.0;
    // const utcDate = new AstroDate(
    //     tai - secsToDays(dAT) + extraSecs / 86400.0,
    // );
    // return utcDate;
}
// Think twice if you want to use this method, returns Barycentric Dynamical Time
export function JDtoTDB(jd) {
    return TTtoTDB(TAItoTT(JDtoTAI(jd)));
}
// Convert from Terrestrial Time to Barycentric Dynamical Time
export function TTtoTDB(tt) {
    return tt + secsToDays(TDBcorrection(tt));
}
// Convert from Atomic Time to Terrestrial TIme
export function TAItoTT(tai) {
    return tai + secsToDays(dTA);
}
export function JDtoTAI(jd) {
    let dAT = LeapSeconds[0][0];
    for (let i = LeapSeconds.length - 1; i > 0; i--) {
        if (jd >= LeapSeconds[i][1]) {
            dAT = LeapSeconds[i][0];
            break;
        }
    }
    return jd + secsToDays(dAT);
}
export function secsToDays(s) {
    return s * (1.0 / 86400.0);
}
export function daysToSecs(d) {
    return d * 86400.0;
}
export function TDBcorrection(tdb) {
    // t is seconds from J2000.0
    const t = daysToSecs(tdb - J2000);
    // Approximate calculation of Earth's mean anomaly
    const M = M0 + M1 * t;
    // Compute the eccentric anomaly
    const E = M + EB * Math.sin(M);
    return K * Math.sin(E);
}
